import './About.css';

function About() {
  return (
    <div className='About'>
      <div className='About__container'>
        <h2 className='About__title'>About Taylor Made</h2>
        <div className='About__content'>
          <p className='About__text'>
            Taylor Made is a leading manufacturer of high-quality products...
          </p>
          {/* Possibly add more in the future */}
        </div>
      </div>
    </div>
  );
}

export default About;
